import { z } from "zod"

// deliberately loose schema for geojson geometry, don't parse every single feature
const geoJsonGeometrySchema = z.object({ type: z.string() }).loose()

export const geoJsonFeatureSchema = z
    .object({
        type: z.literal("Feature"),
        geometry: geoJsonGeometrySchema,
        properties: z.record(z.string(), z.unknown()).nullable(),
    })
    .loose()

export type GeoJsonFeature = z.infer<typeof geoJsonFeatureSchema>
